import React from 'react';
import { Box, Typography, IconButton, Tooltip } from 'components/mui';
import { Paper, Skeleton, Grid } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import useDashboard from 'containers/pages/cantrackDashboard/hooks/useDashboard';
import useDailyWorkPlan from 'containers/pages/cantrackDashboard/hooks/useDailyWorkPlan';
import DashboardGreeting, { DashboardGreetingSkeleton } from './components/DashboardGreeting';
import DailyWorkPlanCard from './components/DailyWorkPlanCard';
import MyCasesSection from './components/MyCasesSection';
import RecentActivitySection from './components/RecentActivitySection';
import PinnedCasesSection from './components/PinnedCasesSection';
import DashboardTimesheets from './components/DashboardTimesheets';

function CANtrackDashboard() {
  const { state, handler } = useDashboard();
  const { state: dwpState, handler: dwpHandler } = useDailyWorkPlan(
    state.dailyWorkPlan,
  );

  if (state.error) {
    return (
      <Box
        component="main"
        sx={{ p: { xs: 2, sm: 3 }, maxWidth: 1400, mx: 'auto', width: '100%' }}
      >
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="error" gutterBottom>
            {state.error}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Something went wrong loading the dashboard. Please try again.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
        p: { xs: 2, sm: 3 },
        maxWidth: 1400,
        mx: 'auto',
        width: '100%',
      }}
    >
      {/* Greeting + Stats */}
      {state.loading ? (
        <DashboardGreetingSkeleton />
      ) : (
        <DashboardGreeting
          userName={state.userName}
          stats={state.stats}
          onRefresh={handler.refresh}
        />
      )}

      {/* Daily Work Plan + Pinned Cases */}
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={8}>
          <DailyWorkPlanCard
            hasDailyPlanCase={dwpState.hasDailyPlanCase}
            planSubmittedToday={dwpState.planSubmittedToday}
            todaysPlan={dwpState.todaysPlan}
            loading={dwpState.loading}
            myCases={state.myCases}
            pinnedCases={state.pinnedCases}
            onSubmit={dwpHandler.submitPlan}
            onUpdate={dwpHandler.updatePlan}
            onConfigureCaseId={dwpHandler.configureDwpCase}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <PinnedCasesSection
            pinnedCases={state.pinnedCases}
            loading={state.loading}
            onCaseClick={handler.onCaseClick}
          />
        </Grid>
      </Grid>

      {/* My Cases (full width) */}
      <MyCasesSection
        cases={state.myCases}
        loading={state.loading}
        onCaseClick={handler.onCaseClick}
      />

      {/* Today's Timesheet + Recent Activity */}
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={8}>
          <DashboardTimesheets />
        </Grid>
        <Grid item xs={12} md={4}>
          <RecentActivitySection
            activity={state.recentActivity}
            loading={state.loading}
            onCaseClick={handler.onCaseClick}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default CANtrackDashboard;
